'use client'

import Link from 'next/link'

import CompetitionCard from '@/components/competition-card'
import { cn } from '@/lib/utils'
import { useReadAllCompetitionsQuery } from '@/redux/competition'

export default function FeaturedCompetition() {
  const { data: allCompetitions } = useReadAllCompetitionsQuery()
  const competition = allCompetitions?.[0]

  if (!competition) return null
  const { description, id } = competition

  return (
    <div className="py-64 bg-[url('/home-images/featured-competition-background.png')] bg-no-repeat bg-size-[1360px_auto] bg-position-[calc(50%+700px)_-120px]">
      <div className="w-(--content-width) mx-auto flex gap-24">
        <CompetitionCard competition={competition} size="lg" className="shrink-0" />
        <div>
          <div>
            <div className="text-5xl font-bold mb-3">
              Featured&nbsp;
              <span className="bg-clip-text text-fill-transparent bg-linear-to-r from-gradient-blue to-gradient-teal">Event</span>
            </div>
            <div className="text-secondary-foreground">{description}</div>
          </div>
          <Link
            href={`/competition/${id}`}
            className={cn(
              'h-[3.5rem] w-[10.75rem] mt-12 rounded-full text-xl font-bold flex items-center justify-center',
              'bg-[url("/home-images/join-button-background.png")] hover:bg-[url("/home-images/join-button-hover-background.png")] bg-no-repeat bg-contain',
              'shadow-[0_2px_18px_2px_#D2DDFF_inset,_0_1px_4px_2px_#D2DDFF_inset,_0_42px_107px_0_rgba(138,167,255,0.34),_0_24.721px_32.257px_0_rgba(138,167,255,0.19),_0_10.268px_13.398px_0_rgba(138,167,255,0.22),_0_3.714px_4.846px_0_rgba(138,167,255,0.3)]',
            )}
          >
            Apply
          </Link>
        </div>
      </div>
    </div>
  )
}
